import Skeleton from '@mui/material/Skeleton';
import './Calculadora.css'

const SkeletonTable = () => {
  return (
    <div className='skelton'>
        <Skeleton sx={{width: '100%', height: '32px'}} />
        <Skeleton sx={{width: '100%', height: '32px'}} />
        <Skeleton sx={{width: '100%', height: '32px'}} />
    </div>

    
  )
}

export default SkeletonTable